import styled from "styled-components";
import { colors } from "healthex-common/colors";
export const Container = styled.div `
    color: ${colors.black_lighter};
    line-height: normal;

    & ul {
        margin-top: 0;
        padding-left: 24px;

        & li {
            padding-left: 4px;
        }
    }
`;
